import { get as getUser } from 'js/lib/user';

import { IdTypes, createFeatureScope } from 'bundles/product-features';
import { isEnterpriseProfileBarEnabled } from 'bundles/unified-home-common/utils/isEnterpriseProfileBarEnabled';

const dailyGoalsFeatureScope = createFeatureScope({
  globalCourseFeatures: {
    enableDailyGoals: true, // value is unused
  },
});

export const useDailyGoalsProductFeature = ({
  shouldSkipQuery = false,
  ssr,
}: {
  shouldSkipQuery?: boolean;
  ssr?: boolean;
}): { enabled: boolean; loading: boolean } => {
  const { features, loading } = dailyGoalsFeatureScope.useProductFeatures({
    idType: IdTypes.User,
    id: String(getUser().id),
    skip: shouldSkipQuery,
    ssr,
  });
  return {
    // Before loading, the default value is `true` based on the generated types
    // coming from the product features configuration repo.
    // So we need to return `false` before loading is complete to avoid the case where we start out
    // by returning `true` and later return `false` when loading is complete.
    enabled: loading ? false : features.get('globalCourseFeatures', 'enableDailyGoals'),
    loading,
  };
};

export const useIsDailyGoalsFeatureEnabled = ({ ssr }: { ssr?: boolean } = {}): {
  isDailyGoalsFeatureEnabled: boolean;
  loadingDailyGoalsFeature: boolean;
} => {
  const isEnabledByEnterpriseProfileBarAndMMM = isEnterpriseProfileBarEnabled();

  const { enabled: isDailyGoalsFeatureEnabled, loading: loadingDailyGoalsFeature } = useDailyGoalsProductFeature({
    // The product feature blocks enterprise users, so if a user is in the enterpise profile bar experiment, we can skip the query.
    shouldSkipQuery: isEnabledByEnterpriseProfileBarAndMMM,
    ssr,
  });

  return {
    isDailyGoalsFeatureEnabled: isEnabledByEnterpriseProfileBarAndMMM || isDailyGoalsFeatureEnabled,
    loadingDailyGoalsFeature: isEnabledByEnterpriseProfileBarAndMMM ? false : loadingDailyGoalsFeature,
  };
};
